import React from 'react';
import useSearchParams from '../../../useSearchParams';
import Header from '../Header';
import Footer from './Footer';

const BounceFilter = () => {
  const {query, setQuery} = useSearchParams();

  return (
    <>
      <Header title="バウンスメール" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-2">
          <label className="flex items-center text-base">
            <input
              type="radio"
              className="form-radio"
              checked={query.isBounced === false}
              onChange={() => setQuery({...query, isBounced: false})}
            />
            <span className="ml-2">配信成功</span>
          </label>
          <label className="flex items-center text-base">
            <input
              type="radio"
              className="form-radio"
              checked={query.isBounced === true}
              onChange={() => setQuery({...query, isBounced: true})}
            />
            <span className="ml-2">バウンス（配信エラー）</span>
          </label>
        </div>
      </div>
      <Footer onClear={() => setQuery({...query, isBounced: null})} />
    </>
  );
};

export default BounceFilter;
